import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { ClientsSection } from "@/components/ClientsSection";
import { ServicesGrid } from "@/components/ServicesGrid";
import { FeaturesShowcase } from "@/components/FeaturesShowcase";
import { CodePreview } from "@/components/CodePreview";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { PricingSection } from "@/components/PricingSection";
import { Newsletter } from "@/components/NewsLetter";
import { CTASection } from "@/components/CTASection";
import { Footer } from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        <HeroSection />
        <ClientsSection />
        <ServicesGrid />
        <FeaturesShowcase />
        <CodePreview />
        <TestimonialsSection />
        <PricingSection />
        <Newsletter />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
